import { lazy } from 'react'
import { confirmable, createConfirmation } from 'react-confirm'
import { load } from './load'

const AuthErrorConfirm = load(lazy(() => import('./AuthErrorConfirm')))

export const confirm = (confirmation: string) =>
  createConfirmation(confirmable(AuthErrorConfirm))({ confirmation })
